import axios from 'axios';

import {BE_SERVER_ENDPOINT, API_PROTOCOL} from '../constants/configs.js';

export function postPdfSanityData(params, sanityData) {
  return axios({
    url: `${API_PROTOCOL}${BE_SERVER_ENDPOINT}/v2.0/pdf-report/users/${params.uuid}/pdf-sanity/${params.pdfName}`,
    method: 'PUT',
    data: sanityData
  }).then(response => {
    return response.data.payload;
  },(error) => {
    return error.data.payload;
  })
}